import { render, staticRenderFns } from "./frontPage.vue?vue&type=template&id=411827fe&scoped=true"
import script from "./frontPage.vue?vue&type=script&lang=js"
export * from "./frontPage.vue?vue&type=script&lang=js"
import style0 from "./frontPage.vue?vue&type=style&index=0&id=411827fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411827fe",
  null
  
)

export default component.exports